import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

window.__ROOT_SEO_BUILD_ID__ = "incident-clean-20260610";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
